import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { saveSession } from '../utils/auth.js';
import Logo from '../components/shared/Logo.jsx';

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    async function handleCallback() {
      try {
        const { data: { session }, error } = await supabase.auth.getSession();

        if (error || !session) {
          navigate('/signup?error=auth_failed', { replace: true });
          return;
        }

        const res = await fetch('/api/auth/google-callback', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${session.access_token}`,
          },
          body: JSON.stringify({
            email: session.user.email,
            supabase_uid: session.user.id,
          }),
        });

        if (!res.ok) {
          navigate('/signup?error=auth_failed', { replace: true });
          return;
        }

        const data = await res.json();
        saveSession(session, data.user);
        navigate('/dashboard', { replace: true });
      } catch {
        navigate('/signup?error=auth_failed', { replace: true });
      }
    }

    handleCallback();
  }, [navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--color-bg)',
      gap: 16,
    }}>
      <Logo size={36} />
      <p style={{
        fontSize: 14,
        color: 'var(--color-text-2)',
        margin: 0,
      }}>
        Signing you in...
      </p>
    </div>
  );
}
